<template>
    <div class="userView">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item ><span style="font-weight:500;">首页</span></el-breadcrumb-item>
        <el-breadcrumb-item ><span style="color:#1571E5 !important;cursor: pointer;">个人中心</span></el-breadcrumb-item>
      </el-breadcrumb>
      <div class="contentBox" v-if="userBol">
        <div class="leftBox">
          <div class="leftTop">
            <!-- <img class="userImg" :src="user.avatar" alt=""> -->
            <img class="userImg" v-if="user.avatar" :src="user.avatar" alt="">
            <img class="userImg" v-else :src="imgObj.headerImg" alt="">

            
            <div class="userName">{{user.username}}</div>
            <div class="userId">ID：{{user.id}}</div>
            <img v-if="user.id&&user.vipInfo.isVip==1" class="vipImg" src="@/assets/user/06_VIP_80px_40px_60px_30px.png" alt="">
          </div>
          <div class="leftBottom">
            <div class="leftBottomBtn" :class="{'btnTrue':btnNum == 1}" @click="btnFun(1)">
              <img v-if="btnNum == 1" src="@/assets/user/07_bill_42px_42px_01.png" alt="">
              <img v-else src="@/assets/user/07_bill_42px_42px_00.png" alt="">
              <span>查看订单</span>
            </div>
            <div class="leftBottomBtn" :class="{'btnTrue':btnNum == 2}" @click="btnFun(2)">
              <img v-if="btnNum ==2" src="@/assets/user/08_collect_42px_42px_01.png" alt="">
              <img v-else src="@/assets/user/08_collect_42px_42px_00.png" alt="">
              <span>我的收藏</span>
            </div>
            <div class="leftBottomBtn" :class="{'btnTrue':btnNum == 3}" @click="btnFun(3)">
              <img src="@/assets/user/09_my_42px_42px_00.png" alt="">
              <span>个人资料</span>
            </div>
          </div>
        </div>
        <div class="rightBox">
          <div class="rightTop">
            <div class="rightTopLeft">
              <span  v-if="user.id&&user.vipInfo.isVip==1" >您已购买</span>
              <span  v-else>您还不是会员</span>
              <img  v-if="user.id&&user.vipInfo.isVip==1"  src="@/assets/user/06_VIP_80px_40px_60px_30px.png" alt="">
            </div>
            <div class="rightTopRight">
              <span  v-if="user.id&&user.vipInfo.isVip==1"  style="margin-right:30px">使用有效期至：<span style="color:#C22424;">{{user.vipInfo.expirationTime.slice(0,10)}}</span></span>
              <div v-if="user.id&&user.vipInfo.isVip==0" class="rightTopBtn"><span @click="vipFun()">立即购买</span></div>
              <div v-if="user.id&&user.vipInfo.isVip==1" class="rightTopBtn"><span @click="vipFun()">立即续费</span></div>
            </div>
          </div>
          <div class="rightBottom" v-if="btnNum == 1">
            <div class="rightTitle">我的订单</div>
            <div style="height:348px">
            <el-table
              :data="tableData"
              :header-cell-style="{'text-align':'center'}"
              :cell-style="{'text-align':'center','height':'60px'}"
              stripe
              style="width: 100%;"
              >
              <el-table-column
                prop="id"
                label="订单号"
                width="240">
              </el-table-column>
              <el-table-column
                prop="goodsName"
                label="商品名称"
                width="120">
              </el-table-column>
              <el-table-column
                prop="amount"
                label="订单金额"
                width="120">
                <template slot-scope="scope">{{ scope.row.amount | amountFil }}</template>
              </el-table-column>
              <el-table-column
                prop="buyTime"
                label="交易时间"
                width="200">
              </el-table-column>
              <el-table-column
                prop="status"
                label="交易状态"
                width="100">
                <template slot-scope="scope">{{ scope.row.status | statusFil }}</template>
              </el-table-column>
            </el-table>
            </div>
            <el-pagination
              style="text-align:center;padding:20px 0;"
              @current-change="handleCurrentChange"
              :page-size="5"
              layout="prev, pager, next"
              :total="total">
            </el-pagination>
            <div class="fpBox">
              <div class="fpTitle">
                发票须知
              </div>
              <div class="fpContent">
                <span style="color: #C22424;font-weight:700">开票时间：</span>
                无特殊或不可抗力情况下，我们将在
                <span style="color: #C22424;">7个工作日内</span>
                为您开票，发票开出后可在您填写的接收邮箱中查看、下载。
              </div>
            </div>
          </div>
          <div class="rightBottom" v-if="btnNum == 2">
            <div class="rightTitle">我的收藏</div>
            <div v-for="(item,index) in collectionInfo" :key="index">
              <tableView  :sendData="item" />
            </div>
            <!-- <tableView  :sendData="{title:'稽查应急问',scKey:'aiw-jcyjw',}" />
            <tableView  :sendData="{title:'引导问',scKey:'aiw-ydw',}" /> -->
            <!-- <div class="rightTypeBox">
              <div class="typeTitle">
                <span class="title">引导问</span>
                <div style="display:inline-block;padding:5px 0;vertical-align: top;cursor: pointer;">
                  <div class="typeIcon">
                    <i class="el-icon-caret-bottom" v-if="false"></i>
                    <i class="el-icon-caret-top" v-else></i>
                  </div>
                </div>
                <div style="float:right;display:inline-block;vertical-align: top;">
                    <div class="allBtn">
                      全选
                    </div>
                    <div class="delBtn">
                      删除
                    </div>
                </div>
              </div>
              <el-table
                :data="jdObj.list"
                style="width: 100%">
                <el-table-column
                  type="selection"
                  width="55">
                </el-table-column>
                <el-table-column
                  prop="title"
                  label="文件名"
                  width="585">
                </el-table-column>
                <el-table-column
                  prop="createTime"
                  label="收藏时间"
                  width="160">
                </el-table-column>
              </el-table>
              <el-pagination
                style="text-align:center;padding:20px 0;"
                @current-change="jdChange"
                :page-size="5"
                layout="prev, pager, next"
                :total="jdObj.total">
              </el-pagination>
            </div>
            <div class="rightTypeBox">
              <div class="typeTitle">
                <span class="title">热点预警</span>
                <div style="display:inline-block;padding:5px 0;vertical-align: top;cursor: pointer;">
                  <div class="typeIcon">
                    <i class="el-icon-caret-bottom" v-if="false"></i>
                    <i class="el-icon-caret-top" v-else></i>
                  </div>
                </div>
                <div style="float:right;display:inline-block;vertical-align: top;">
                    <div class="allBtn">
                      全选
                    </div>
                    <div class="delBtn">
                      删除
                    </div>
                </div>
              </div>
              <el-table
                :data="dyObj.list"
                style="width: 100%">
                <el-table-column
                  type="selection"
                  width="55">
                </el-table-column>
                <el-table-column
                  prop="title"
                  label="文件名"
                  width="585">
                </el-table-column>
                <el-table-column
                  prop="createTime"
                  label="收藏时间"
                  width="160">
                </el-table-column>
              </el-table>
              <el-pagination
                style="text-align:center;padding:20px 0;"
                @current-change="dyChange"
                :page-size="5"
                layout="prev, pager, next"
                :total="dyObj.total">
              </el-pagination>
            </div>
            <div class="rightTypeBox">
              <div class="typeTitle">
                <span class="title">判例</span>
                <div style="display:inline-block;padding:5px 0;vertical-align: top;cursor: pointer;">
                  <div class="typeIcon">
                    <i class="el-icon-caret-bottom" v-if="false"></i>
                    <i class="el-icon-caret-top" v-else></i>
                  </div>
                </div>
                <div style="float:right;display:inline-block;vertical-align: top;">
                    <div class="allBtn">
                      全选
                    </div>
                    <div class="delBtn">
                      删除
                    </div>
                </div>
              </div>
              <el-table
                :data="plObj.list"
                style="width: 100%">
                <el-table-column
                  type="selection"
                  width="55">
                </el-table-column>
                <el-table-column
                  prop="title"
                  label="文件名"
                  width="585">
                </el-table-column>
                <el-table-column
                  prop="createTime"
                  label="收藏时间"
                  width="160">
                </el-table-column>
              </el-table>
              <el-pagination
                style="text-align:center;padding:20px 0;"
                @current-change="plChange"
                :page-size="5"
                layout="prev, pager, next"
                :total="plObj.total">
              </el-pagination>
            </div> -->
          </div>
        </div>
      </div>
      <div class="userContentBox" v-else>
        <div class="userImg">
          <img src="@/assets/user/00_Illustration_420px_520px.png" alt="">
        </div>
        <div class="imgBtn">
          修改头像
        </div>
        <div class="userXinxi">
          <div class="line">
            <span>用户名</span>
            <div class="inputBox"><el-input v-model="userXinxi.name"></el-input></div>
          </div>
          <div class="line">
            <span>邮箱</span>
            <div class="inputBox"><el-input v-model="userXinxi.email"></el-input></div>
          </div>
          <div class="line">
            <span>手机</span>
            <div class="inputBox">xxxxxxxxxxx<div class="blueBtn2">修改手机</div></div>
          </div>
          <div class="line">
            <span>登录密码</span>
            <div class="inputBox"><div class="blueBtn">修改密码</div></div>
          </div>
          <div class="line">
            <span>微信账号</span>
            <div class="inputBox">xxxxxxx</div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
//import dayjs from 'dayjs';
import { orderList,userDetail,getCollection } from "@/api/api";

import tableView from './tableView/index.vue'

//获取图片位置
import headerImg from '@/assets/user/head.png'

export default {
    props: {

    },
    components: {
      tableView
    },
    data() {
        return {
          imgObj:{
            headerImg
          },
          //收藏列表
          collectionInfo:[
            {
              title:'稽查应急问',
              scKey:'aiw-jcyjw',
            },
            {
              title:'引导问',
              scKey:'aiw-ydw',
            },
            {
              title:'热点预警',
              scKey:'aiw-rdyj',
            },
            {
              title:'焦点诊断',
              scKey:'aiw-jdzd',
            },
            {
              title:'行业诊断',
              scKey:'aiw-hyzd',
            },
            {
              title:'问题诊断',
              scKey:'aiw-wtzd',
            },
            {
              title:'政策诊断',
              scKey:'aiw-zczd',
            }
          ],
          tableData:[],
          user:{},
          page:1,
          total:0,
          btnNum:1,
          fgObj:{
            list:'',
            total:0,
            page:1
          },
          jdObj:{
            list:'',
            total:0,
            page:1
          },
          dyObj:{
            list:'',
            total:0,
            page:1,
          },
          plObj:{
            list:'',
            total:0,
            page:1
          },
          userBol:true,
          userXinxi:{
            name:'',
            email:'',
            phoneNum:'',
            password:'',
            wxUser:''
          }
        };
    },
    computed: {

    },
    filters:{
      amountFil(v){
        return '￥'+String(v);
      },
      statusFil(v){
        switch (Number(v)) {
          case 0:
            return '待支付'
            break;
          case 1:
            return '已支付'
            break;
          case 2:
            return '支付失败'
            break;
          default:
            return '状态错误'
            break;
        }
      },
      // timeFil(v){
      //   if(v&&v.expirationTime != null){
      //     let newTime = v.expirationTime.slice(0,10);
      //     return newTime
      //     //return dayjs(v.expirationTime).format('YYYY-MM-DD')
      //   }else{
      //     return '已到期'
      //   }
      // }
    },
    created() {
      this.orderList();
      this.scList();
    },
    mounted() {
        console.log(this.$store.state.user)
        if(this.$store.state.user.id){
            this.user = this.$store.state.user;
            this.userXinxi.name = this.user.username
            this.userXinxi.email = this.user.email
            this.userXinxi.phoneNum = this.user.mobile
        }


    //   this.timer = setTimeout(() => {
    //     if(this.$parent.user){
    //       this.user = this.$parent.user
    //       this.userXinxi.name = this.user.username
    //       this.userXinxi.email = this.user.email
    //       this.userXinxi.phoneNum = this.user.mobile
    //       clearInterval(this.timer)
    //     }
    //   }, 100);
    },
    watch: {
      
    },
    methods: {
        fgChange(){},
        jdChange(){},
        dyChange(){},
        plChange(){},
      vipFun(){
        window.open('https://zsdy-mall-pc.shui12366.com/goodsType?appCode=guanwang', "_blank");
      },
      btnFun(v){
        switch (v) {
          case 3:
            // 跳转个人资料
            // this.userBol = !this.userBol;
            window.open('https://passport.shui12366.com/ucenter/index?bar=off', "_blank");
            break;
          default:
            this.userBol = true;
            this.btnNum = v;
            break;
        }
      },
      // 收藏历史
      scList(){
        let data = {
          pageSize: 999,
          pageNo: 1
        }
        getCollection(data).then(res => {
          console.log(res)
        })

      },
      handleCurrentChange(v){
        this.page = v;
        this.orderList();
      },
      orderList(){
        let data = {
          page: this.page,
          limit: 5,
          appCode: 'aiw'
        }
        orderList(data).then((res) => {
          console.log(res);
          this.tableData = res.data.rows;
          this.total = res.data.total;
        }).catch((err) => {
          
        });
      }
    },
};
</script>

<style lang="scss" scoped>
.userView{
    width:1200px;
    margin:30px auto 0;
}
.contentBox{
  width: 100%;
  min-height: 810px;
  padding-top: 25px;
  padding-bottom: 50px;
  position: relative;
  .leftBox{
    width: 340px;
    margin-right: 10px;
    display: inline-block;
    vertical-align: top;
    // height: 400px;
    // box-sizing: border-box;
    // background: #FFFFFF;
    // box-shadow: 0px 2px 3px 0px rgba(0, 0, 0, 0.2);
    // border-top: 4px solid #1571e5;
    .leftTop{
      width: 340px;
      height: 400px;
      margin-bottom: 10px;
      box-sizing: border-box;
      background: #FFFFFF;
      box-shadow: 0px 2px 3px 0px rgba(0, 0, 0, 0.2);
      border-top: 4px solid #1571e5;
      
      .userImg{
        width: 120px;
        height: 120px;
        margin: 80px 110px 40px;
      }
      .userName{
        font-family: Source Han Sans CN;
        font-size: 20px;
        font-weight: normal;
        line-height: 24px;
        text-align: center;
        letter-spacing: 0em;
        color: #3D3D3D;
        text-align: content;
      }
      .userId{
        font-family: Source Han Sans CN;
        font-size: 16px;
        font-weight: normal;
        line-height: 18px;
        text-align: center;
        letter-spacing: 0em;
        color: #888888;
        text-align: content;
        margin-top: 20px;
        margin-bottom: 20px;
      }
      .vipImg{
        width: 80px;
        height: 40px;
        margin: 0 130px;
      }
    }
    .leftBottom{
      width: 340px;
      height: 400px;
      box-sizing: border-box;
      padding: 36px 20px 40px;
      border-top: 4px solid #1571e5;
      background: #FFFFFF;
      box-shadow: 0px 2px 3px 0px rgba(0, 0, 0, 0.2);
      .leftBottomBtn{
        width: 100%;
        height: 80px;
        box-sizing: border-box;
        cursor: pointer;
        padding: 16px 40px;
        // background: #EEF8FF;
        background: #F8F8F8;
        margin-bottom: 30px;
        img{
          width: 48px;
          height: 48px;
        }
        span{
          margin-left: 20px;
          font-family: Source Han Sans CN;
          font-size: 22px;
          font-weight: normal;
          line-height: 48px;
          letter-spacing: 0em;
          // color: #1571E5;
          color: #000000;
          display: inline-block;
          vertical-align: top;
        }
      }
      .btnTrue{
        background: #EEF8FF;
        span{
          color: #1571E5;
          font-weight: bold;
        }
      }
    }
  }
  .rightBox{
    width: calc(100% - 350px);
    display: inline-block;
    vertical-align: top;
    .rightTop{
      width: 100%;
      height: 100px;
      box-sizing: border-box;
      border-top: 4px solid #1571e5;
      background: #FFFFFF;
      box-shadow: 0px 2px 3px 0px rgba(0, 0, 0, 0.2);
      margin-bottom: 10px;
      padding: 35px 20px 35px 40px;
      .rightTopLeft{
        line-height: 30px;
        font-size: 18px;
        display: inline-block;
        span{
          display: inline-block;
          vertical-align: top;
          margin-right: 13px;
        }
        img{
          width: 60px;
          height: 30px;
        }
      }
      .rightTopRight{
        line-height: 30px;
        font-size: 18px;
        display: inline-block;
        vertical-align: top;
        float: right;
        span{
          display: inline-block;
          vertical-align: top;
        }
        .rightTopBtn{
          cursor: pointer;
          vertical-align: top;
          display: inline-block;
          width: 100px;
          height: 30px;
          border-radius: 4px;
          opacity: 1;
          background: #1571E5;
          text-align: center;
          span{
            line-height: 30px;
            font-family: Source Han Sans CN;
            font-size: 16px;
            font-weight: bold;
            letter-spacing: 0.1em;
            color: #FFFFFF;
          }
        }
      }
    }
    .rightBottom{
      width: 100%;
      // height: 700px;
      box-sizing: border-box;
      border-top: 4px solid #1571e5;
      background: #FFFFFF;
      box-shadow: 0px 2px 3px 0px rgba(0, 0, 0, 0.2);
      padding: 30px 20px 45px 30px;
      .rightTitle{
        padding-bottom: 30px;
        font-family: Source Han Sans CN;
        font-size: 24px;
        font-weight: bold;
        line-height: 24px;
        letter-spacing: 0em;
        color: #105AA5;
      }
      .fpBox{
        width: 100%;
        height: 130px;
        background-color: #f8f8f8;
        box-sizing: border-box;
        padding: 20px;
        margin-top: 21px;
        .fpTitle{
          font-family: Source Han Sans CN;
          font-size: 18px;
          font-weight: bold;
          line-height: 24px;
          letter-spacing: 0em;
          color: #1571E5;
        }
        .fpContent{
          margin-top: 15px;
          font-family: Source Han Sans CN;
          font-size: 16px;
          font-weight: normal;
          line-height: 24px;
          letter-spacing: 0em;
        }
      }
      
    }
  }
}

// 个人资料
.userContentBox{
  width: 100%;
  height: 780px;
  border-top: 4px solid #0f59a4;
  box-sizing: border-box;
  text-align: center;
  background-color: #fff;
  margin-top: 20px;
  .userImg{
    width: 120px;
    height: 120px;
    margin: 80px auto 30px;
    img{
      width: 100%;
      height: 100%;
      border-radius: 50%;
    }
  }
  .imgBtn{
    width: 100px;
    height: 40px;
    margin: 0 auto;
    background-color: #1571e5;
    font-family: Source Han Sans CN;
    font-size: 16px;
    font-weight: normal;
    line-height: 40px;
    text-align: center;
    letter-spacing: 0em;
    color: #FFFFFF;
    cursor: pointer;
    margin-bottom: 80px;
  }
  .userXinxi{
    .line{
      width: 450px;
      height: 40px;
      margin: 0 auto 30px;
      span{
        display: inline-block;
        margin-right: 20px;
        line-height: 40px;
      }
      .inputBox{
        float: right;
        width: 300px;
        height: 40px;
        display: inline-block;
        font-family: Source Han Sans CN;
        font-size: 20px;
        font-weight: normal;
        line-height: 40px;
        letter-spacing: 0em;
        color: #888888;
        text-align: left;
        .blueBtn{
          width: 100%;
          height: 40px;
          background-color: #1571e5;
          font-family: Source Han Sans CN;
          font-size: 16px;
          font-weight: normal;
          line-height: 40px;
          text-align: center;
          letter-spacing: 0em;
          color: #FFFFFF;
          cursor: pointer;
        }
        .blueBtn2{
          width: 100px;
          height: 40px;
          float: right;
          background-color: #1571e5;
          font-family: Source Han Sans CN;
          font-size: 16px;
          font-weight: normal;
          line-height: 40px;
          text-align: center;
          letter-spacing: 0em;
          color: #FFFFFF;
          cursor: pointer;
        }
      }
    }
  }
}
</style>
